// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var JsxRuntime = require("react/jsx-runtime");
var ShortText$ReactHooksTemplate = require("./ShortText.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var QuestionTextPreview$ReactHooksTemplate = require("./QuestionTextPreview.res.js");

function ShortTextPreview(props) {
  var onChange = props.onChange;
  var language = props.language;
  var shortText = props.shortText;
  var handleOnchange = function ($$event) {
    var value = $$event.target.value;
    var firstChar = value[0];
    var check = Belt_Array.getBy([
          "<",
          "=",
          "+",
          "-",
          "@"
        ], (function (x) {
            return firstChar === x;
          }));
    if (check !== undefined || value.trim() === "") {
      return Curry._1(onChange, ShortText$ReactHooksTemplate.setAnswer(shortText, undefined));
    } else {
      return Curry._1(onChange, ShortText$ReactHooksTemplate.setAnswer(shortText, value));
    }
  };
  var onTitleChange = function (html) {
    Curry._1(onChange, ShortText$ReactHooksTemplate.setText(shortText, html));
  };
  var onDescriptionChange = function (html) {
    Curry._1(onChange, ShortText$ReactHooksTemplate.setDescription(shortText, html));
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionTextPreview$ReactHooksTemplate.make, {
                      text: ShortText$ReactHooksTemplate.getTextTranslation(shortText, SurveyLanguage$ReactHooksTemplate.name(language)),
                      description: ShortText$ReactHooksTemplate.getDescriptionTranslation(shortText, SurveyLanguage$ReactHooksTemplate.name(language)),
                      onTitleChange: onTitleChange,
                      onDescriptionChange: onDescriptionChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Input",
                              className: "text-aurometalsaurus text-sm mb-2 font-normal"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "h-48-px py-2 px-4 bg-alicebluepurple border-b border-gray-500 focus:border-gray-600 text-xs w-full",
                              placeholder: ShortText$ReactHooksTemplate.getPlaceholderTranslation(shortText, SurveyLanguage$ReactHooksTemplate.name(language)),
                              type: "text",
                              value: ShortText$ReactHooksTemplate.answerToString(shortText),
                              onChange: handleOnchange
                            })
                      ]
                    }),
                props.mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "w-full p-16"
            });
}

var make = ShortTextPreview;

exports.make = make;
/* react/jsx-runtime Not a pure module */
